import { Html } from '@react-three/drei'
import { useThree } from '@react-three/fiber'

const Overlay = ({
  show = false,
  transparent = true,
  className = '',
  children,
}: {
  show?: boolean
  transparent?: boolean
  className?: string
  children: any
}) => {
  const { gl } = useThree()

  return (
    <Html
      prepend={false}
      zIndexRange={[100, 0]}
      style={{
        display: show ? 'block' : 'none',
        // pointerEvents: 'none',
      }}
    >
      <div
        className={className}
        style={{
          zIndex: -5,
          width: '100vw',
          height: '100vh',
          transform: 'translate(-50%, -50%)',
          flexWrap: 'nowrap',
          display: 'flex',
          flexBasis: '100%',
          backgroundColor: transparent ? 'transparent' : '#000000aa',
          justifyContent: 'center',
          alignItems: 'center',
          // marginTop: 30,
          // backgroundColor: pointerEvents ? '#f00a' : '#0f0a'
        }}
      >
        {children}
      </div>
    </Html>
  )
}
export default Overlay
